
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faKey, faUnlockAlt } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Form, Card, Button, Container, InputGroup } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';
import { useState } from "react";
import { Routes } from "../../routes";
import { resetPasswordConfirm } from "../../api/services";
import { useHistory } from "react-router-dom";
import PasswordInput from "../components/PasswordInput";

export default () => {
  const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
  const [new_password, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [otp, setOtp] = useState("");
  const history = useHistory();
  const [success, setSuccess] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    const Email = sessionStorage.getItem("email") || "";
    console.log({ Email, otp, new_password });
    if (new_password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }


    try {
      const data = await resetPasswordConfirm({
        email: Email,
        otp,
        new_password,
      });

      console.log("password reset Success:", data);

      setSuccess("Your Password is reset successfully!!");
      await delay(2000); // Waits for 1 second
      history.push(Routes.Signin.path);
      // Redirect to login
      // window.location.href = "/otp-verification";

    } catch (error) {
      console.log("signin Error:", error.response?.data || error.message);
      setError(error.response?.data.error);
    }
  };

  return (
    <main>
      <section className="bg-soft d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <Row className="justify-content-center">
            <p className="text-center">
              <Card.Link as={Link} to={Routes.Signin.path} className="text-gray-700">
                <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Back to sign in
              </Card.Link>
            </p>
            <Col xs={12} className="d-flex align-items-center justify-content-center">
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <h3 className="mb-4">Reset password</h3>
                {
                  success && (<div class="alert alert-success">
                    {success}
                  </div>)
                }
                {error && (<div class="alert alert-danger">
                  {error}
                </div>)}
                <Form className="mt-4" onSubmit={handleSubmit}>
                  <Form.Group id="otp" className="mb-4">
                    <Form.Label>Your OTP</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faKey} />
                      </InputGroup.Text>
                      <Form.Control autoFocus required type="otp" placeholder="XXXXXX"
                        value={otp} onChange={(e) => setOtp(e.target.value)} />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group id="password" className="mb-4">
                    <Form.Label>Your Password</Form.Label>
                    {/* <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUnlockAlt} />
                      </InputGroup.Text> */}
                    <PasswordInput
                      required
                      type="password" placeholder="Password"
                      value={new_password} onChange={(e) => setNewPassword(e.target.value)} />
                    {/* </InputGroup> */}
                  </Form.Group>
                  <Form.Group id="confirmPassword" className="mb-4">
                    <Form.Label>Confirm Password</Form.Label>
                    {/* <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUnlockAlt} />
                      </InputGroup.Text> */}
                    <PasswordInput
                      required
                      type="password" placeholder="Confirm Password"
                      value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                    {/* </InputGroup> */}
                  </Form.Group>
                  <Button variant="primary" type="submit" className="w-100">
                    Reset password
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
